//component to handle html text spit back from Python.
//used in the results window on the vocab trainer
//handled from the VocabMC component
import React from 'react';

const Word = ({ word, color, bold }) => {
    const style = {
        color: color || 'inherit',
        fontWeight: bold ? 'bold' : 'normal'
      };
  return <span style={style}>{word} </span>;
};

export const StructuredSentence = ({ sentence }) => {
    if (Array.isArray(sentence)) {
      return (
        <div>
          {sentence.map((wordObj, index) => {
            if (typeof wordObj === 'object' && wordObj !== null && 'word' in wordObj) {
              return <Word key={index} word={wordObj.word} color={wordObj.color}  bold={wordObj.bold} />;
            } else {
              console.error('Invalid word object at index', index, ':', wordObj);
              return <span key={index}>{String(wordObj)} </span>;
            }
          })}
        </div>
      );
    } else if (typeof sentence === 'string') {
      return <div>{sentence}</div>;
    } else {
      console.error('Expected an array or string for sentence, but got:', sentence);
      return <div>Error: Invalid sentence format</div>;
    }
  };